import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class LicenseStore extends PaginatedStore {

  constructor(scope) {
    super(new Connection('licenses', scope))
  }

}



// WEBPACK FOOTER //
// client/stores/licenses.js